export default "__VITE_ASSET__40ae35aa__"